import React, { useState } from "react";
import close from "../../../../assets/img/icons/Vector copy.svg";
import loc from "../../../../assets/img/icons/location-bbold-green.svg";
import SearchInput from "../../../shared/SearchInput";
import IconBox from "../../../shared/IconBox";
import Search from "../../../../assets/img/icons/search-normal-green.svg";
import arrow from "../../../../assets/img/icons/arrow-left-green.svg";
import Button from "../../../shared/Button";
import useFetch from "../../../../hooks/useAxios";
import CityModal2 from "../../../layouts/Home/CityModal/CityModal";
const CityModal = ({
  notshowCount = false,
  choseoneCity = false,
  closeModal,
  setChoseCity,
  chosenCity,
  setchoseCityId,
  choseCityId,
  setStateinfo,
  StateResults,
  setChosenState,
  Stateinfo
}) => {
  const [isState, setIsState] = useState(true);
  const [ChoseStateid, setChoseStateid] = useState(null);
  const [ChoseState, setChoseState] = useState([]);

  const findState = e => {
    setStateinfo(StateResults.filter(i => i.name.startsWith(e.target.value)));
    // if(e.target.value === ""){
    //     setStateinfo([...StateResults])
    // }
  };
  const chooseState = id => {
    setChoseStateid(id);
    setChoseState(Stateinfo.filter(i => i.id === id));
    if (setChosenState){
      setChosenState(Stateinfo.filter(i => i.id === id));
      
    }
  };
  return (
    <div className="ModalBackground GuestCount CityModal">
      <div className="ModalBackground--container p-[25px] relative">
        {isState
          ? <div>
              <div className="flex justify-between  items-center">
                <div className="flex justify-between  items-center gap-[8px]">
                  <h2 className="text-[#292D32] text-[20px] font-[700]">
                    لیست شهر ها
                  </h2>
                </div>

                <button onClick={closeModal}>
                  <img src={close} />
                </button>
              </div>
              <hr className="my-[10px]" />
              <div className="SearchInput relative mb-[19px]">
                <input
                  className="SearchInput__input"
                  placeholder="جست و جو در بین شهر ها و روستا ها"
                  onChange={e => findState(e)}
                />
                <IconBox white small >
                  {" "}<img className="" src={Search} />
                </IconBox>
              </div>
              <div className="StateModal-body pb-[80px]">
                {Stateinfo.map(i =>
                  <div
                    className={`StateModal-box ${i.id === ChoseStateid
                      ? "StateModal-box--active"
                      : ""}`}
                    onClick={() => chooseState(i.id)}
                  >
                    <div>
                      <h4>
                        {i.name}
                      </h4>
                      <p>
                        {i.cities[0].title},{i.cities[1].title},{i.cities[2].title}
                      </p>
                    </div>
                    {!notshowCount &&
                      <div className="flex items-center gap-[8px]">
                        <div className="StateModal-box--residencecount">
                          {i.residences_count} اقامتگاه
                        </div>
                        <img src={arrow} />
                      </div>}
                  </div>
                )}
              </div>
              <div className="flex StateModal-buttonrow">
                <Button varient="white" onClick={() => closeModal}>
                  انصراف
                </Button>

                <Button
                  varient="primary"
                  onClick={() => {
                    if (ChoseStateid) {
                      setIsState(false);
                    }
                  }}
                >
                  تایید مقصد
                </Button>
              </div>
            </div>
          : <CityModal2
              setChoseCity={setChoseCity}
              closeModal={() => closeModal()}
              ChoseState={ChoseState}
              chosenCity={chosenCity}
              setIsState={setIsState}
              choseoneCity={choseoneCity}
              notshowCount={notshowCount}
              setchoseCityId={setchoseCityId}
              choseCityId={choseCityId}
            />}
      </div>
    </div>
  );
};

export default CityModal;
{
  /* <div className="SearchInput relative mb-[19px]">
<input
  className="SearchInput__input"
  placeholder="جست و جو در بین شهر ها و روستا ها"
/>
<IconBox white small>
  {" "}<img className="" src={Search} />
</IconBox>
</div> */
}
